import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Forceurbaniaonrentinkatrajpune() {



    const cardData =
    {
        keyword: 'Force Urbania on Rent in Katraj Pune',
        heading: 'Urbania on rent in pune: Force Urbania on Rent in Katraj Pune',
        headingDescription: 'Urbania On Rent in Pune offers reliable and comfortable Force Urbania on Rent in Katraj Pune for corporate groups, families, tourists, and event travelers across the southern region of Pune. Our well‑maintained Force Urbania fleet provides spacious seating, air‑conditioned comfort, and smooth performance, making it ideal for corporate travel, airport transfers, weddings, sightseeing, and outstation journeys from Katraj Pune. With professional chauffeurs, flexible one‑way and round‑trip rental options, and convenient doorstep pickup from Katraj, Kondhwa, Dhankawadi, Bibwewadi, Warje, Balewadi, and Pune Airport, we ensure a safe and stress‑free travel experience. Backed by 24/7 booking support, punctual service, and transparent pricing, Urbania On Rent in Pune stands out as the trusted choice for Force Urbania hire in Katraj Pune.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by Peshwa Bajirao I, is Pune’s iconic fort and a symbol of Maratha heritage. The massive stone walls, grand gateways such as the Delhi Darwaza, and sprawling lawns showcase the grandeur of the Peshwa era. Though much of it was destroyed in a fire, the remnants still reflect royal architecture and historical significance. The evening light-and-sound show vividly narrates Maratha history, making it a must-visit site for history enthusiasts and tourists alike."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892, Aga Khan Palace is closely tied to India’s freedom struggle, as Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum displaying Gandhi’s personal artifacts, photographs, and letters. Its expansive gardens, Italian arches, and serene atmosphere offer a peaceful retreat while preserving the legacy of sacrifice and patriotism."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is renowned for the historic 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive to the fort, explore ancient ramparts, memorials, and enjoy panoramic views of the Sahyadri ranges. Local vendors serve traditional pithla-bhakri meals, making the experience a blend of history, adventure, and local culture."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual landmark, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily, especially during Ganesh Chaturthi when grand celebrations are held. The temple trust is also known for charitable activities, making it a center of devotion, spirituality, and community service."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic city views after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines, a museum, and tranquil surroundings make it a favorite spot for spiritual seekers, photographers, and tourists. Sunrise and sunset visits provide breathtaking vistas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, an 8th-century rock-cut shrine, is dedicated to Lord Shiva and carved from a single basalt rock. The temple features monolithic pillars, a circular Nandi pavilion, and a peaceful sanctum. Despite its urban location, it retains a tranquil ambiance, showcasing ancient Indian craftsmanship and providing a quiet spiritual retreat for visitors."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, offering a comprehensive glimpse into India’s cultural past. From traditional musical instruments, ornaments, and household antiques to sculptures and paintings, the museum is a treasure trove of art and heritage. The recreated Mastani Mahal is a major highlight, making it Pune’s living archive of craftsmanship."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for meditation, wellness, and spiritual transformation. Spread across landscaped gardens, it offers guided meditation sessions, holistic therapies, and mindfulness programs. Visitors from around the world come seeking relaxation, inner peace, and rejuvenation in a serene and luxurious environment."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, manicured lawns, and seasonal flowerbeds. The garden is ideal for leisurely walks, photography, and family outings, blending Japanese aesthetics with Indian greenery to create a peaceful and picturesque urban sanctuary."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a favorite leisure spot near Pune. Surrounded by hills and expansive water views, it is especially picturesque during the monsoon. Visitors enjoy street food, sunset views, and relaxed outings. The dam also serves as the starting point for treks to Sinhagad Fort, making it a hub for both relaxation and adventure."
  }
],






"services": [
{
"name": "Force Urbania on Rent in Katraj Pune",
"description": "Force Urbania on Rent in Katraj Pune offers well-maintained Urbania buses for both local and outstation travel. Ideal for families, corporate groups, and tourists, these buses provide comfortable seating, professional chauffeurs, and a hassle-free travel experience across Katraj and nearby Pune areas."
},
{
"name": "Katraj Urbania Bus Hire",
"description": "Katraj Urbania Bus Hire provides convenient rental services with AC and non-AC Urbania buses for city travel, sightseeing, and group tours. Perfect for families, corporate trips, and friends, ensuring safety, comfort, and timely journeys."
},
{
"name": "Urbania Rental Service Katraj Pune",
"description": "Urbania Rental Service Katraj Pune offers flexible rental options for Urbania buses with experienced drivers. Suitable for corporate events, family outings, weddings, and outstation trips, ensuring reliability, comfort, and professional service."
},
{
"name": "Urbania AC Bus on Rent Katraj",
"description": "Urbania AC Bus on Rent Katraj provides fully air-conditioned Urbania buses for comfortable city travel, corporate trips, and long-distance journeys. Features include climate-controlled interiors and professional chauffeurs for a smooth ride."
},
{
"name": "Corporate Urbania Hire Katraj",
"description": "Corporate Urbania Hire Katraj delivers professional transport solutions for business travel, office events, and employee commutes. Offers AC buses, trained drivers, and punctual service for a seamless corporate travel experience."
},
{
"name": "Urbania for Outstation Katraj Pune",
"description": "Urbania for Outstation Katraj Pune offers AC and non-AC buses for long-distance travel, sightseeing tours, and weekend getaways. Ensures comfortable seating, luggage support, and courteous drivers familiar with the routes."
},
{
"name": "Urbania Airport Transfer Katraj",
"description": "Urbania Airport Transfer Katraj provides timely pick-up and drop services to and from Pune Airport. Ideal for families, tourists, and corporate travelers seeking stress-free and comfortable airport transport."
},
{
"name": "Luxury Force Urbania Katraj",
"description": "Luxury Force Urbania Katraj offers high-end, air-conditioned buses with plush seating, modern interiors, and professional drivers. Perfect for VIP travel, weddings, corporate outings, and luxury family trips."
},
{
"name": "Affordable Urbania Hire Katraj",
"description": "Affordable Urbania Hire Katraj provides budget-friendly rental options for city travel, local sightseeing, and group outings without compromising on safety, comfort, or convenience."
},
{
"name": "Chauffeur Driven Force Urbania Katraj",
"description": "Chauffeur Driven Force Urbania Katraj ensures a stress-free travel experience with verified and experienced drivers. Ideal for families, corporate groups, and tourists seeking safe and reliable transport across Katraj and Pune."
},
{
"name": "Urbania for Wedding Events Katraj",
"description": "Urbania for Wedding Events Katraj offers spacious and air-conditioned buses for wedding guests and party travel. Ensures punctual service, comfort, and elegance for special celebrations."
},
{
"name": "Urbania for Office Trips Katraj",
"description": "Urbania for Office Trips Katraj provides organized and professional transport for corporate outings, team trips, and business travel. Features AC buses, comfortable seating, and trained chauffeurs for smooth office travel."
},
{
"name": "Best Urbania Rental Katraj Pune",
"description": "Best Urbania Rental Katraj Pune offers top-rated Urbania buses with excellent customer service, timely pickups, and comfortable travel for both local and outstation trips. Suitable for families, corporate groups, and tourists."
},
{
"name": "Urbania Group Travel Katraj",
"description": "Urbania Group Travel Katraj provides large-capacity buses for group outings, excursions, and tours. Ensures safe, comfortable, and convenient travel for friends, families, and corporate groups."
},
{
"name": "Reliable Urbania Hire Katraj Pune",
"description": "Reliable Urbania Hire Katraj Pune offers dependable and punctual Urbania bus services for city and outstation travel. Known for safety, comfort, and professional drivers, making group travel seamless and enjoyable."
}
],
"tableData": [
["Force Urbania on Rent in Katraj Pune", "Katraj Urbania Bus Hire"],
["Urbania Rental Service Katraj Pune", "Urbania AC Bus on Rent Katraj"],
["Corporate Urbania Hire Katraj", "Urbania for Outstation Katraj Pune"],
["Urbania Airport Transfer Katraj", "Luxury Force Urbania Katraj"],
["Affordable Urbania Hire Katraj", "Chauffeur Driven Force Urbania Katraj"],
["Urbania for Wedding Events Katraj", "Urbania for Office Trips Katraj"],
["Best Urbania Rental Katraj Pune", "Urbania Group Travel Katraj"],
["Reliable Urbania Hire Katraj Pune", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Force Urbania on Rent in Katraj Pune",
        "WhyChoosedescription": "Force Urbania on Rent in Katraj Pune is ideal for family outings, group travel, corporate trips, weddings, and outstation journeys, offering comfort and spacious seating."
    },
    {
        "WhyChooseheading": "Spacious and Well-Equipped Force Urbania Vehicles",
        "WhyChoosedescription": "Force Urbania on Rent in Katraj Pune provides modern vehicles with air-conditioning, ample legroom, and comfortable seating for both short and long trips."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "All Urbania vehicles come with trained and licensed drivers familiar with Katraj, Pune, Lonavala, and nearby routes, ensuring safe, punctual, and hassle-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Choose Force Urbania on Rent in Katraj Pune for competitive rates with no hidden charges, making group and family travel budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Force Urbania on Rent in Katraj Pune offers round-the-clock booking assistance and customer support for inquiries, reservations, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Force Urbania on Rent in Katraj Pune is available for hourly rentals, full-day bookings, multi-day trips, corporate travel, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles for Force Urbania on Rent in Katraj Pune are regularly cleaned, sanitized, and maintained to ensure passenger safety and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Force Urbania on Rent in Katraj Pune guarantees on-time pickups and reliable service, ensuring smooth and stress-free travel experiences."
    }
]
}

const faqData = [
    {
        question: 'Is Force Urbania on Rent in Katraj Pune available for local and outstation travel?',
        answer: 'Yes, Force Urbania on Rent in Katraj Pune can be booked for city travel, corporate trips, family outings, and long-distance journeys.',
    },
    {
        question: 'How can I book Force Urbania on Rent in Katraj Pune?',
        answer: 'You can book Force Urbania on Rent in Katraj Pune via phone, WhatsApp, or online for easy and quick reservations.',
    },
    {
        question: 'Why choose Force Urbania on Rent in Katraj Pune?',
        answer: 'Force Urbania on Rent in Katraj Pune offers spacious seating, professional drivers, clean vehicles, and transparent pricing for corporate, family, and group travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers for Force Urbania on Rent in Katraj Pune are licensed, trained, and experienced in handling Force Urbania vehicles safely.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Force Urbania on Rent in Katraj Pune allows flexible pickup and drop locations across Katraj, Pune, and nearby areas.',
    },
    {
        question: 'Is Force Urbania on Rent in Katraj Pune available 24x7?',
        answer: 'Yes, Force Urbania on Rent in Katraj Pune operates 24x7 to meet your travel needs anytime.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all vehicles are regularly sanitized, cleaned, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Force Urbania on Rent in Katraj Pune accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during trips?',
        answer: 'Yes, dedicated customer support is available throughout your journey for smooth and stress-free travel.',
    },
    {
        question: 'Can Urbania be used for corporate, family, and outstation trips?',
        answer: 'Yes, Force Urbania on Rent in Katraj Pune is ideal for group trips, corporate travel, family outings, and long-distance journeys.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Amit Deshmukh',
        feedback: 'Force Urbania on Rent in Katraj Pune provided a comfortable and punctual ride for our family outing. Highly recommended.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Priya Kulkarni',
        feedback: 'We hired Force Urbania on Rent in Katraj Pune for a corporate trip. Clean, reliable, and excellent service.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Rahul Patil',
        feedback: 'Force Urbania on Rent in Katraj Pune made our group travel smooth and stress-free. Great service.',
        rating: 5,
    },
];



































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Force Urbania on Rent in Katraj Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/force-urbania-katraj.jpg",
  "description": "Force Urbania on Rent in Katraj Pune provides AC and non-AC Force Urbania buses for corporate travel, outstation trips, airport transfers, weddings, office trips, and group travel. Chauffeur-driven Force Urbania buses ensure safe, comfortable, and reliable transportation in Katraj and nearby areas of Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/force-urbania-on-rent-katraj-pune"
  }
};



    return (
        <div>

<Helmet>
  <title>
    Call:+91 9209423113 | Force Urbania on Rent in Katraj Pune | AC & Luxury Urbania Bus Hire 
  </title>

  <meta
    name="description"
    content="Book Force Urbania on Rent in Katraj Pune for corporate travel, outstation trips, airport transfers, weddings, office trips, and group travel. AC and non-AC Force Urbania buses with chauffeur-driven service ensure safe, comfortable, and reliable transportation in Katraj, Pune."
  />

  <meta
    name="keywords"
    content="Force Urbania on Rent in Katraj Pune, Katraj Urbania Bus Hire, Urbania Rental Service Katraj Pune, Urbania AC Bus on Rent Katraj, Corporate Urbania Hire Katraj, Urbania for Outstation Katraj Pune, Urbania Airport Transfer Katraj, Luxury Force Urbania Katraj, Affordable Urbania Hire Katraj, Chauffeur Driven Force Urbania Katraj, Urbania for Wedding Events Katraj, Urbania for Office Trips Katraj, Best Urbania Rental Katraj Pune, Urbania Group Travel Katraj, Reliable Urbania Hire Katraj Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/105.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Forceurbaniaonrentinkatrajpune;